import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import styles from "./Common.module.scss";
import { data } from './local';
import { Typography, CardHeader, CardMedia, CardContent, Button, Container, Tab, Tabs, Grid, Chip, Avatar, Card, Paper } from '@material-ui/core';
import { getWinners } from './services';
import { eventEmitter, getCategoryMap } from './common';
import { useSelector } from 'react-redux';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import Tooltip from '@material-ui/core/Tooltip';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { LineScalePulseOut } from 'react-pure-loaders';

const Awards: FunctionComponent<any> = ({ token }: any) => {


    const languageSelected: any = useSelector((state: any) => state.lang);
    const languageData: any = data;
    const { awardSection } = languageData[languageSelected];
    const [value, setValue] = useState<any>(2);
    const currentYear = new Date().getFullYear();
    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue);
    };
    const years = [currentYear - 2, currentYear - 1, currentYear]
    // Handlers


    // End Of Loader
    return (
        <Container maxWidth={"lg"} className={styles.awardSection}>
            <div >
                {/* <Typography className={styles.awardHeader} >{awardSection.title}</Typography> */}

                <Grid item xs={12}>
                    <Tabs centered
                        value={value}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        aria-label=" tabs "

                    >{
                            years.map((year: any, key: number) =>

                                <Tab className={styles.tabLite} label={year} key={key} />
                            )
                        }
                    </Tabs>
                </Grid>
                <Awardees year={years[value]} awardSection={awardSection} />

                {/* <Grid container justify="center" alignItems="center" >
                    <Button variant="outlined" className={styles.awardViewBttn} >{awardSection.viewMoreBttn}</Button>
                </Grid> */}
            </div>
        </Container>


    )
}





export const Awardees = ({ year, awardSection }: any) => {

    const [awardees, setAwardees] = useState<any>([]);
    const [open, setOpen] = React.useState(false);
    /*Loader*/
    const handleCloseLoader = () => {
        setOpen(false);
    };
    const handleToggleLoader = () => {
        setOpen(!open);
    };
    const getWinnersList = React.useCallback(async (year: any) => {
        handleToggleLoader();
        setAwardees([])
        try {
            let winnerList: any = await getWinners(year);
            if (winnerList?.length != null && winnerList?.length > 0) {
                setAwardees(winnerList);
            }
        } catch (error) {
            console.error("Error fetching winners:", error);
        } finally {
            handleCloseLoader();
        }
    }, []);

    useEffect(() => {
        if (year) {
            getWinnersList(year);
        }
    }, [year, getWinnersList]);

    useEffect(() => {
        const handleCategoriesCreated = (categoryMap: any) => {
            if (year) {
                getWinnersList(year);
            }
        };
        
        eventEmitter.on("createdCategories", handleCategoriesCreated);
        
        return () => {
            eventEmitter.off("createdCategories", handleCategoriesCreated);
        };
    }, [year, getWinnersList]);
    return <Grid container direction="row"
    justifyContent="space-around"
    alignItems="center" className={styles.scrollableContent}>
        <div hidden={!open}>
                <LineScalePulseOut
                    color={'#035295'}
                    loading={open}
                />
        </div>
        {
            awardees && Array.isArray(awardees) && awardees.length > 0 ? awardees.map((awardee: any, key: number) =>
                <div className={styles.gridImages} key={key}>
                    <div>
                    <Paper elevation={3} className={styles.awardDetails} >
                        <img className={styles.imgStyle}  src={awardee.imageId} width={250} height={336} alt={awardee?.awardeeName || 'Awardee'} />
                        <div style={{ textAlign: "center", float: "right", marginRight: "60px" }}>
                            <span>
                                <Tooltip title={awardSection.imgText}>
                                    <img className={styles.playicon} src="/img/playbutton_icon.png" alt="Play video" onClick={() => { window.open(awardee?.videoLink, '_blank') }} />
                                </Tooltip>
                            </span>
                        </div>
                    </Paper>
                    </div>
                    <div >
                        <div className={styles.awardeeDetails}>
                            <div className={styles.bottomLeft}>{awardee?.awardeeName}</div>
                            <div className={styles.bottomLeft2}>{awardee?.organization}</div>
                            <div className={styles.bottomLeft1}>{awardee?.location}</div>
                        </div>
                    </div>
                </div>
            ) : (
                <div style={{ textAlign: 'center', padding: '20px', width: '100%' }}>
                    <Typography variant="body1" style={{ color: '#00338e' }}>
                        {open ? '' : 'No system awardees found for this year'}
                    </Typography>
                </div>
            )
        }
        {/* <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
        >
            <CircularProgress color="inherit" />
        </Backdrop> */}
    </Grid>
}
export default Awards